// extracted by mini-css-extract-plugin
module.exports = {"btn":"PostToConnectionsButton_btn__rBt5e"};